import http from '@/utils/request';

// 查询健康数据
export const queryHealthData = (params) => {
  const url = '/monitorPlatform/queryHealthData';
  return http.get({
    url,
    params,
  });
};
//   // 查询接口请求趋势
// export const queryApiTendency = (params) => {
//   const url = '/monitorPlatform/queryApiTendency';
//   return http.get({
//     url,
//     params,
//   });
// };
  // 查询接口请求趋势
export const queryApiTendency = (params) => {
  const url = '/monitorPlatform/queryApiGroupTendency';
  return http.get({
    url,
    params,
  });
};
// 查询接口请求数 top
export const queryApiRequestCountTop = (params) => {
  const url = '/monitorPlatform/queryApiRequestCountTop';
  return http.get({
    url,
    params,
  });
};
// 查询接口错误数 top
export const queryApiErrorCountTop = (params) => {
  const url = '/monitorPlatform/queryApiErrorCountTop';
  return http.get({
    url,
    params,
  });
};
// 查询资源数量
export const queryResourceCount = (params) => {
  const url = '/monitorPlatform/queryResourceCount';
  return http.get({
    url,
    params,
  });
};
// 查询ecs概况
export const queryEcsSummary = (params) => {
  const url = '/monitorPlatform/queryEcsSummary';
  return http.get({
    url,
    params,
  });
};
// 查询k8s概况
export const queryK8sSummary = (params) => {
  const url = '/monitorPlatform/queryK8sSummary';
  return http.get({
    url,
    params,
  });
};
// 查询rds概况
export const queryRdsSummary = (params) => {
  const url = '/monitorPlatform/queryRdsSummary';
  return http.get({
    url,
    params,
  });
};
// 查询redis概况
export const queryRedisSummary = (params) => {
  const url = '/monitorPlatform/queryRedisSummary';
  return http.get({
    url,
    params,
  });
};
// 查询es概况
export const queryEsSummary = (params) => {
  const url = '/monitorPlatform/queryEsSummary';
  return http.get({
    url,
    params,
  });
};
// 查询slb概况
export const querySlbSummary = (params) => {
  const url = '/monitorPlatform/querySlbSummary';
  return http.get({
    url,
    params,
  });
};
